import React from 'react';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';
import { createBem, BemMethod } from '@om-fe/utils';

export enum BonusType  {
    Single = 'single',
    Multi = 'multi'
}

interface MatchListSpecialHeaderProps {
    readonly bonusType: BonusType;
}

const bem: BemMethod = createBem('BonusContainerTitle');

export const MatchListSpecialHeader = ({
    bonusType
}: MatchListSpecialHeaderProps) => {
    const { gettext } = useI18NContext();
    
    return (
        <>
            {bonusType === BonusType.Single && <div className={bem()}>{gettext('Bonus Dana')}</div>}
            {bonusType === BonusType.Multi && <div className={bem()}>{gettext('Bonus Plus')}</div>}
        </>
    )
}